import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/virtual-makeup-instagram"
    path="business/services/virtual-makeup-instagram"
    element={<AsyncPage />}
  />,
];
